// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"570":"ja-JP-main-json","764":"zh-TW-main-json","946":"en-US-main-json","988":"zh-CN-main-json"}[chunkId] + "." + {"570":"785ed91f","764":"8870dbcc","946":"ed784cd1","988":"28b9be9b"}[chunkId] + ".chunk.js";
};